import { useState } from "react";
import meme2 from "./assets/home.webp";
import MusicPlayer from "./MusicPlayer";
import OriginComic from "./components/OriginComic";
import JoinPresale from "./components/JoinPresale";
import TokenUtility from "./components/TokenUtility";
import FmexDatingSection from "./components/FmexDatingSection";
import Roadmap from "./components/FmexRoadmap";
import Header from "./components/Header";
import AnnouncementBar from "./components/AnnouncementBar";
import Pettynomics from "./components/Pettynomics";

// src/FMEXHome.jsx
import React from "react";
import { motion } from "framer-motion";
import "./index.css"; 

function ComicButton({ label, onClick, base, hover, active }) {
  const [style, setStyle] = useState(base);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setStyle(hover)}
      onMouseLeave={() => setStyle(base)}
      onMouseDown={() => setStyle(active)}
      onMouseUp={() => setStyle(hover)}
      className="h-14 px-6 md:px-8 rounded-2xl border-4 border-black font-darumadrop text-lg md:text-xl tracking-wide uppercase cursor-pointer select-none"
      style={{
        backgroundColor: style.bg,
        color: style.text,
        boxShadow: style.shadow,
        transform: style.transform,
        transition: "background-color 0.1s, color 0.1s",
      }}
    >
      {label}
    </button>
  );
}

export default function FMEXHome() {  

  const [openIndex, setOpenIndex] = useState(null);


  const smoothScroll = (e, targetId) => {
  e.preventDefault();
  const el = document.querySelector(`#${targetId}`);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

  return (
    <div className="relative min-h-screen font-sans antialiased text-black overflow-hidden">
      {/* Halftone background */}
    <div className="relative overflow-hidden">
    <div
      className="absolute inset-0 -z-10 bg-cover bg-left md:bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/tropicalbg6.webp')" }}
    />
      <div className="fmex-halftone" aria-hidden />

    <Header />
    <AnnouncementBar />

    {/* Main content spacer */}
<div className="h-28 md:h-32" />

      
      <main className="relative z-20">
        {/* HERO */}
        <section id="hero" className="-mt-16 md:-mt-6 pb-16">
          <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <motion.div initial={{ x: -80, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: .6 }} style={{ pointerEvents: "auto" }} className="space-y-6">
              <div className="inline-block p-1 bg-white border-comic shadow-2xl rotate-1">
                <h2 className="text-4xl sm:text-6xl font-black leading-tight tracking-tight font-display">TURN YOUR BREAKUP INTO A <span className="text-hotpink">BREAKOUT!</span></h2>
              </div>

              <p className="text-lg md:text-xl text-center md:text-left font-comfortaa font-black max-w-xl text-black">Welcome to FMEX - <span className="bg-white/70 rounded px-1">Eff My Ex Coin</span>, where heartbreak becomes a weapon, humor becomes an asset, and a new era of emotionally charged meme finance takes over the blockchain.</p>

              <div className="flex gap-4 items-center justify-center md:justify-start flex-nowrap">
                  <ComicButton
                   label="BUY FMEX"
                   onClick={(e) => smoothScroll(e, "presale")}
                   base={{ bg: "#FF5C00", text: "#000000", shadow: "0 6px 0 #000", transform: "translateY(0px)" }}
                   hover={{ bg: "#0d7a35", text: "#ffffff", shadow: "0 4px 0 #000", transform: "translateY(2px)" }}
                   active={{ bg: "#16a34a", text: "#ffffff", shadow: "0 2px 0 #000", transform: "translateY(4px)" }}
                 />
                 <a href="/fmex-whitepaper.pdf" target="_blank" rel="noopener noreferrer">
                <ComicButton
                  label="WHITEPAPER"
                  onClick={() => {}}
                  base={{ bg: "#ffffff", text: "#000000", shadow: "0 6px 0 #000", transform: "translateY(0px)" }}
                  hover={{ bg: "#0a8638", text: "#ffffff", shadow: "0 4px 0 #000", transform: "translateY(2px)" }}
                  active={{ bg: "#2f965c", text: "#ffffff", shadow: "0 2px 0 #000", transform: "translateY(4px)" }}
                />
               </a>
                </div>

            </motion.div>

            <motion.div initial={{ scale: .9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: .6 }} className="flex justify-center">
              <div className="relative w-80 h-80 sm:w-96 sm:h-96 flex items-center justify-center mt-4">
                <div className="absolute -inset-1 bg-fmexyellow rotate-3 border-comic rounded-2xl shadow-fmex-lg" />
                <div className="relative z-20 w-64 h-64 sm:w-80 sm:h-80 border-[6px] border-black bg-white rounded-xl overflow-hidden flex items-center justify-center">
          <img
            src={meme2}
            alt="FMEX Meme"
            className="object-cover w-full h-full"
          />
        </div>

                {/* BOOM crown - tilted and positioned at top-right */}
    <div className="absolute -top-6 -right-6 sm:-top-8 sm:-right-8 rotate-12 z-50">
      <svg
        className="w-28 h-16 sm:w-32 sm:h-22"
        viewBox="0 0 120 80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="10,40 30,10 50,40 70,10 90,40 110,10 105,70 60,60 15,70"
          fill="#ffffffff"
          stroke="#000000ff"
          strokeWidth="4"
        />
        <text
          x="60"
          y="48"
          textAnchor="middle"
          fontWeight="800"
          fontSize="17"
          fill="#000000ff"
        >
          UNFAZED!
        </text>
      </svg>
    </div>
              </div>
            </motion.div>
          </div>
        </section>

        <OriginComic />

        <JoinPresale />

        </main>
       </div>

             

    <div className="relative overflow-hidden">
    <div
      className="absolute inset-0 -z-10 bg-cover bg-center md:bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/images/hike.webp')" }}
    />    

<Pettynomics />
  <section id="pettynomics" className="hidden relative w-full min-h-screen py-20 md:py-36 justify-center overflow-hidden">

  {/* Pettynomics */}
  <div
    className="relative mx-auto max-w-5xl p-10 md:p-20"
    // On medium screens and up, apply card styles: bg-[#BEEAFF], rounded, shadow, border
    style={{
      // ... (rest of your style attributes for the main container)
      background: 'rgb(190, 234, 255, 0)', // Default transparent background for mobile
    }}
  >
    {/* Card background visible only on desktop */}
    <div
      className="hidden md:block absolute inset-0 rounded-3xl shadow-[0_0_0_6px_white] border-[5px]"
      style={{
        background: '#BEEAFF', // Visible background for desktop
        borderImage: "linear-gradient(45deg,#ff00ff,#00eaff,#ff9900,#ff00c8) 1",
        borderImageSlice: 1,
      }}
    />

    {/* Content is placed above the absolute inner div */}
    <div className="relative">
      <h2 className="text-center font-darumadrop text-4xl md:text-5xl font-black tracking-wide text-[#222] drop-shadow-sm mb-4">
        PETTYNOMICS
      </h2>

      <div className="flex flex-col md:flex-row items-start justify-center gap-10">
        {/* LEFT TEXT LIST */}
        <div className="space-y-4 text-lg font-semibold text-[#1d1d1d] w-full">
          
          {/* CSS Grid for consistent column alignment */}
          <div className="grid grid-cols-[50px_20px_1fr] items-center ml-8 md:ml-0 gap-4">
            <span className="font-black text-2xl">39%</span>
            <span className="w-4 h-4 rounded-full border-2 border-black bg-[#FF5050]"></span>
            <p>Community</p>
          </div>

          <div className="grid grid-cols-[50px_20px_1fr] items-center ml-8 md:ml-0 gap-4">
            <span className="font-black text-2xl">20%</span>
            <span className="w-4 h-4 rounded-full border-2 border-black bg-[#E98B37]"></span>
            <p>Therapy and Healing</p>
          </div>

          <div className="grid grid-cols-[50px_20px_1fr] items-center ml-8 md:ml-0 gap-4">
            <span className="font-black text-2xl">15%</span>
            <span className="w-4 h-4 rounded-full border-2 border-black bg-[#8c52ff]"></span>
            <p>Revenge Marketing</p>
          </div>

          <div className="grid grid-cols-[50px_20px_1fr] items-center ml-8 md:ml-0 gap-4">
            <span className="font-black text-2xl">10%</span>
            <span className="w-4 h-4 rounded-full border-2 border-black bg-[#ffde59]"></span>
            <p>Commitment Vault</p>
          </div>

          <div className="grid grid-cols-[50px_20px_1fr] items-center ml-8 md:ml-0 gap-4">
            <span className="font-black text-2xl">10%</span>
            <span className="w-4 h-4 rounded-full border-2 border-black bg-[#c1ff72]"></span>
            <p>CEX Reserve</p>
          </div>

          <div className="grid grid-cols-[50px_20px_1fr] items-center ml-8 md:ml-0 gap-4">
            <span className="font-black text-2xl">6%</span>
            <span className="w-4 h-4 rounded-full border-2 border-black bg-[#00bf63]"></span>
            <p>Ritual Burn</p>
          </div>

        </div>

        {/* RIGHT SIDE: Supply Info and Image */}
        <div className="flex flex-col justify-center items-center gap-4">
          
          {/* Moved the supply info up here, adding a margin bottom */}
          <div className="text-center ml-8 md:ml-0 mt-6 md:mt-0">     
            <h3 className="font-black font-darumadroptext text-xl">Token Address</h3>
            <p className="font-semibold font-comfortaa text-lg"><strong>SOL:</strong> Coming Soon</p>       
          </div>

          
          
          {/* Image Placement */}
          <img
            src="/images/pettynomics.png"
            className="md:hidden ml-10 w-96 h-auto"
            alt="Pettynomics chart visualization"
          />

          <img
            src="/images/pettynomics2.png"
            className="hidden md:block h-auto w-[48rem]"
            alt="Pettynomics chart visualization"
          />
        </div>
      </div>    

    </div>
  </div>
</section>


        <Roadmap />

        </div>

        <FmexDatingSection />

        <div className="relative overflow-hidden">
    
      
       
       {/* Desktop BG */}
       <div
         className="absolute inset-0 -z-10 bg-cover bg-center bg-no-repeat"
         style={{ backgroundImage: "url('/images/bottombg.webp')" }}
       />

  
       
      {/* other sections */}
      <TokenUtility />  {/* ✅ no comma, no closing tag */}
      {/* maybe more sections */}

 

      <section id="FAQ" className="w-full pb-24 px-6">
      <div className="max-w-3xl mx-auto text-center mt-0 mb-12">
        <h2 className="uppercase font-darumadrop text-5xl text-black drop-shadow-md">
          Petty FAQ
        </h2>
        <p className="font-extrabold text-sm md:text-base font-comfortaa text-black mt-2">
          Your ex won’t give you answers, but we will.
        </p>
      </div>

      <div className="space-y-4 max-w-3xl mx-auto">

        {/* 1 */}
        <details open={openIndex === 0} className="bg-white border-4 border-black rounded-2xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 0 ? null : 0);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-xl text-black transition-transform active:scale-[0.98]"
          >
            What is FMEX?
            <span className="text-3xl font-black leading-none">
              {openIndex === 0 ? "−" : "+"}
            </span>
          </summary>
          <p className="mt-3 text-black font-bold font-comfortaa">
            FMEX (Eff My Ex Coin) is a revenge-powered memecoin on Solana,
            created for anyone who’s ever been played, dumped, ghosted, or
            breadcrumbed. It’s therapy, but on-chain.
        </p>
        </details>

        {/* 2 */}
        <details open={openIndex === 1} className="bg-white border-4 border-black rounded-3xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 1 ? null : 1);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-xl text-black transition-transform active:scale-[0.98]"
          >
            Why Solana?
            <span className="text-3xl font-black leading-none">
              {openIndex === 1 ? "−" : "+"}
            </span>
          </summary>
          <p className="mt-3 font-comfortaa font-bold text-black">
            Because FMEX moves fast. unlike your ex replying to your texts.
            Solana gives cheap, instant transactions perfect for a coin fueled
            by pure emotional damage.
        </p>
        </details>

        {/* 3 */}
        <details open={openIndex === 2} className="bg-white border-4 border-black rounded-3xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 2 ? null : 2);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-xl text-black transition-transform active:scale-[0.98]"
          >
            What’s the purpose of FMEX?
            <span className="text-3xl font-black leading-none">
              {openIndex === 2 ? "−" : "+"}
            </span>
          </summary>
          <ul className="mt-3 font-comfortaa font-bold text-black pl-3 list-disc list-inside">
    <span className="font-bold">FMEX exists to:</span>
    <li>Help you heal financially, if not emotionally</li>
    <li>Turn heartbreak into generational wealth</li>
    <li>Let you say “fuck my ex” without sending a long paragraph</li>
  </ul>
        </details>

        {/* 4 */}
        <details open={openIndex === 3} className="bg-white border-4 border-black rounded-3xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 3 ? null : 3);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-xl text-black transition-transform active:scale-[0.98]"
          >
            How can I buy $FMEX?
            <span className="text-3xl font-black leading-none">
              {openIndex === 3 ? "−" : "+"}
            </span>
          </summary>
          <p className="mt-3 font-comfortaa font-bold text-black">
            $FMEX is currently in presale mode, you can only purchase it directly via the official FMEX website. 
            ⚠️ Caution: Do not attempt to buy FMEX from Pump, Raydium, or any “bro trust” platform… That’s not $FMEX
            that’s Fake-MEX, and you’re about
            to get emotionally and financially humbled. <br />
            <span className="italic font-semibold">
              Stay official. Stay unscammed. Stay winning.
            </span>
  </p>
        </details>

        {/* 5 */}
        <details open={openIndex === 4} className="bg-white border-4 border-black rounded-3xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 4 ? null : 4);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-xl text-black transition-transform active:scale-[0.98]"
          >
            What makes FMEX different from other meme coins?
            <span className="text-3xl font-black leading-none">
              {openIndex === 4 ? "−" : "+"}
            </span>
          </summary>
          <p className="mt-3 font-comfortaa font-bold text-black">
    Most meme coins offer “community.” <br />
            We offer utility, closure, therapy, receipts, and the emotional intelligence
            your ex never had.
  </p>
        </details>

        {/* 6 */}
        <details open={openIndex === 5} className="bg-white border-4 border-black rounded-3xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 5 ? null : 5);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-lg text-black transition-transform active:scale-[0.98]"
          >
            Why the FMEX App?
            <span className="text-3xl font-black leading-none">
              {openIndex === 5 ? "−" : "+"}
            </span>
          </summary>
          <p className="mt-3 font-comfortaa font-bold text-black">
         Because attention isn’t progress.
         The FMEX App connects ambitious individuals through accountability and measurable action. 
         Most people scroll. FMEX users build.
         If you’re serious about 1000x, your circle can’t be average.
        </p>
        </details>

        {/* 7 */}
        <details open={openIndex === 6} className="bg-white border-4 border-black rounded-3xl p-5">
          <summary
            onClick={(e) => {
              e.preventDefault();
              setOpenIndex(openIndex === 6 ? null : 6);
            }}
            className="uppercase flex justify-between items-center cursor-pointer font-darumadrop font-semibold text-lg text-black transition-transform active:scale-[0.98]"
          >
            When is FMEX listing?
            <span className="text-3xl font-black leading-none">
              {openIndex === 6 ? "−" : "+"}
            </span>
          </summary>
          <p className="mt-3 font-comfortaa font-bold text-black">
         FMEX will list after all presale stages are complete.
         The projected CEX listing date is February 14, 2027, because what better day to
            launch a heartbreak-powered coin than Valentine’s Day? <br />
            Mark your calendar. While everyone else is crying, we’ll be posting charts.
        </p>
        </details>

      </div>
    </section>
    
 

        {/* JOIN */}
        <section id="join" className="py-16 mt-32 md:mt-24">
          <div className="max-w-7xl mx-auto px-7 grid grid-cols-1 md:grid-cols-2 gap-8 items-center pb-12">
            <div className="flex flex-col items-center md:items-start text-center md:text-left">
              <h3 className="text-3xl font-bold font-darumadrop text-white drop-shadow-[3px_3px_0px_#030303] mb-4">Join the FMEX Army!</h3>
              

              <div className="flex gap-3">
         {/* Telegram */}
         <motion.a
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          href="https://t.me/fmexportal"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 border-comic rounded-lg bg-white font-bold flex items-center justify-center"
        >
          <img src="/images/telegram.png" className="w-5 h-5" alt="Telegram" />
        </motion.a>
       
         {/* X / Twitter */}
         <motion.a
           whileHover={{ scale: 1.1 }}
           whileTap={{ scale: 0.9 }}
           href="https://x.com/fmextoken"
           target="_blank"
           rel="noopener noreferrer"
           className="px-4 py-2 border-comic rounded-lg bg-white font-bold flex items-center justify-center"
         >
        <img src="/images/x.png" className="w-5 h-5" alt="X" />
         </motion.a>

         {/* Discord */}
         <motion.a
           whileHover={{ scale: 1.1 }}
           whileTap={{ scale: 0.9 }}
           href="https://t.me/fmexportal"
           target="_blank"
           rel="noopener noreferrer"
           className="px-4 py-2 border-comic rounded-lg bg-white font-bold flex items-center justify-center"
         >
           <img src="/images/discord.png" className="w-5 h-5" alt="Discord" />
         </motion.a>
       </div>
            </div>

            <div className="flex justify-center px-6 md:px-10 mt-10">
  <div className="bg-fmexyellow border-comic shadow-2xl rounded-2xl p-6 md:p-8 max-w-lg w-full">

    <div className="text-center space-y-4">

      <div className="uppercase font-bold text-xl md:text-2xl font-darumadrop">
        Subscribe for Airdrops
      </div>

      <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 justify-center">
        <input
          className="w-full px-4 py-3 rounded-xl border-comic placeholder-black/50 font-semibold"
          placeholder="email@domain.com"
        />
        <button className="px-5 py-3 bg-hotpink text-white font-bold rounded-xl border-comic hover:scale-105 transition-transform">
          SUBSCRIBE
        </button>
      </div>

    </div>


              </div>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="py-8 md:py-16">
          <div className="max-w-4xl mx-auto px-6 text-center font-bold font-comfortaa text-sm text-black">
            <div>Disclaimer: FMEX is a culture-driven meme coin with evolving utility. DYOR. Crypto is high risk, your portfolio can thrive, or break your heart twice. Invest responsibly</div>
            <div className="mt-2">© {new Date().getFullYear()} $FMEX</div>
          </div>
        </footer>
        </div>
      
    <MusicPlayer />
    </div>
  );
}


